import styled, { css } from 'styled-components'
import { colors } from 'app/theme/colors'

export const FormContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  // flex-basis: 75%;
  flex: 0.9;
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const BottomContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 12px;
`

export const TimingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 0.5;
`

export const OtherDetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  & > * {
    margin-bottom: ${(props) =>
      props.$isCheckoutMode ? '2px' : '14px'} !important;
  }

  .MuiOutlinedInput-root {
    border-radius: 4px;
  }

  .MuiOutlinedInput-input {
    font-size: 14px;
  }

  .MuiListItem-root {
    font-size: 14px;
  }

  #payment-cycle-label {
    font-size: 14px;
  }

  div[class^='MuiInputBase-root'] {
    display: flex;
  }
`

export const DescriptionContainer = styled.div`
  margin: 0 1em;
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const ActionButtons = styled.div`
  /* margin-right: 10em; */
`

export const Title = styled.h2`
  margin: 0;
  margin-bottom: 4px;
`

export const SubTitle = styled.h4`
  font-weight: normal;
  margin: 0;
  font-size: 14px;
`

export const ImageContainer = styled.div`
  width: calc(max(3em, 72px));
  height: calc(max(3em, 72px));
  border-radius: 8px;
  overflow: hidden;
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
`

export const BodyText = styled.p`
  margin: 0.5em 0 0 0;
  font-size: 14px;
`

export const PriceContainer = styled.div`
  border: 1px solid ${colors.ohOrange};
  border-radius: 24px;
  padding: 4px 16px;
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const PriceText = styled.span`
  font-size: 18px;
  color: ${colors.ohOrange};
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0;
`

export const PriceSmallText = styled.span`
  font-size: 12px;
  color: ${colors.ohOrange};
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
`

export const Icon = styled.img`
  height: 18px;
  width: 18px;
  margin-top: -2px;
`

export const PriceReqContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: ${colors.ohRed};
`

export const DetailsContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  font-size: 12px;
`

export const ErrorContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${colors.ohRed};
`

export const PriceDetailsContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`
export const PaymentHelperText = styled.div`
  line-height: 1.2;
  margin-left: -14px;
  color: #0000008f;
  font-size: 12px;
  margin-top: 4px;
`
